// extracted by mini-css-extract-plugin
module.exports = {"filterContainer":"index_filterContainer__2n2EF","tagIcon":"index_tagIcon__1jIsq"};